var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "url(#pattern0_2_7808)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2_7808",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_7808",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_7808",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACvElEQVR4nO3cS24TQRRG4UsGPCQW4DACsglgwGtHCSwCRkSAFGAQ9sAAhecuCKwApIBAhCAzO6jSZckId7vbbt9UVf+flIkdl6uPynbsuNpMRKRcwBngPvAF+AzcC5ed9LyKApwGXvC/PeDsSc+v9MgTiu0QeUKxHSJPKLZDZMV2jDyhle0QWbEdIyu2Y2TFrnnH93JOsKbr29x22O8gabeSj1/cGq5vPYYNEe1X8vFqrPuFRcYaFOBRlzBNoTvE3rYhAdaA311W37zQLWP/Ak7ZwEKP20ZuG7pF7HCfazYkwPO2kbuEnhN714YGOB9jj+ND+kHTi1WX0FOxt+PY4T52w33aUNHyObNr6OnxB/W8vKxFQ0tHCu0ErWiFLgpa0Y1xbgHPgI/A0TKxVnHbOKcwt6fATcsNsAG8azjAf7Qcs/fbzvAGuGQ5AK4B3zocHAmFDr4CVy1lwEXgoOOBkVho4kLZsFQBbxc4KBIMHby3FAG3FzwgEg1Nki+Q8a+LWcbAJjBacvyFQzeMuQ5sNXxk+8RSA3yqmexmT+P3Hnpq7Ds1w+9bauLHkbOMMgg9qhn+0FKzyhAljN+b3EOg0BWFLiQEWtEVhS4kBFrRFYUuJARa0RWFLiQEWtEVhS4kBFrRFYUuJARa0RWF9gvxY8bw33OZf06hH88Y/mGP4yt0AJwL/8OLe1/Cz064zHqi0E5fLFdoJwrtRKGdKLQThXai0E4U2olCO1FoJwrtRKGdKLQThXai0E4U2olCO1FoJzmFPlzlZqFVAi7UzP2nZbT9bcsSB9zNaftbOBXDLOO4aXLdEhM3dIY9hn9q5r5jiZ6bozTXLUXAa8qxZ6WdRiJB4TQSly1l4aQi8eQiuToArlgOwulyMn0aeRUelZYb4Eb8Gtd+w6b8kxTm9CF+vSzNFz4RERERERFbsb/e4WU42tkODgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.946780d5b8226ed15324187b66ed3ad1.svg";
export { ForwardRef as ReactComponent };